/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { AccessRequestDetail } from './AccessRequestDetail';
import {
    AccessRequestDetailFromJSON,
    AccessRequestDetailFromJSONTyped,
    AccessRequestDetailToJSON,
    AccessRequestDetailToJSONTyped,
} from './AccessRequestDetail';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetAccessRequestsMe200Response
 */
export interface GetAccessRequestsMe200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetAccessRequestsMe200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetAccessRequestsMe200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {Array<AccessRequestDetail>}
     * @memberof GetAccessRequestsMe200Response
     */
    result: Array<AccessRequestDetail>;
}

/**
 * Check if a given object implements the GetAccessRequestsMe200Response interface.
 */
export function instanceOfGetAccessRequestsMe200Response(value: object): value is GetAccessRequestsMe200Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function GetAccessRequestsMe200ResponseFromJSON(json: any): GetAccessRequestsMe200Response {
    return GetAccessRequestsMe200ResponseFromJSONTyped(json, false);
}

export function GetAccessRequestsMe200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccessRequestsMe200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': ((json['result'] as Array<any>).map(AccessRequestDetailFromJSON)),
    };
}

export function GetAccessRequestsMe200ResponseToJSON(json: any): GetAccessRequestsMe200Response {
    return GetAccessRequestsMe200ResponseToJSONTyped(json, false);
}

export function GetAccessRequestsMe200ResponseToJSONTyped(value?: GetAccessRequestsMe200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': ((value['result'] as Array<any>).map(AccessRequestDetailToJSON)),
    };
}

